import { useHistory } from 'react-router-dom';
import { useMenuItemsStore } from '../../pages/chat/store';

function getNextObjectByField(array: any, currentValue: string | number, fieldName: string) {
  const currentIndex = array.findIndex((obj: any) => obj[fieldName] === currentValue);
  return (currentIndex === -1 || currentIndex === array.length - 1) 
      ? null 
      : array[currentIndex + 1];
}

const useStageInfo: any = () => {
  const history = useHistory()
  const menuItems = useMenuItemsStore((state) => state.menuItems);
  if(menuItems) {
    const data = getNextObjectByField(menuItems, history.location.pathname, 'routePath')
    return data
  }
  else return []
};

export default useStageInfo;
